import { isBrowser, isTablet } from 'react-device-detect'
import { CSSProperties, ReactElement } from 'react'
import { ButtonOLD, Icon } from '@lmc/ui-kit'
import { colors } from '@lmc/common/constants'
// @ts-ignore
import { hexToRgbA } from '@lmc/common/utils'

type ReviewFooterProps = {
  cancelButtonText: string
  handleCancel: () => void
  handleSave: () => void
  saveButtonText: string
}

export const ReviewFooter = ({
  cancelButtonText,
  handleCancel,
  handleSave,
  saveButtonText,
}: ReviewFooterProps): ReactElement => (
  <div style={styles.bottomBar as CSSProperties}>
    <ButtonOLD
      type="secondary"
      style={{ marginRight: 10 }}
      onClick={() => handleCancel()}
    >
      {cancelButtonText}
    </ButtonOLD>
    <ButtonOLD
      onClick={() => handleSave()}
      type="primary"
      style={{ marginRight: 10 }}
      icon={<Icon name="CheckOutlined" />}
    >
      {saveButtonText}
    </ButtonOLD>
  </div>
)

const styles = {
  bottomBar: {
    display: 'flex',
    position: 'fixed',
    bottom: 0,
    background: colors.white,
    right: 0,
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw',
    height: 72,
    alignItems: 'center',
    justifyContent: 'flex-end',
    boxShadow: `0px 0px 7px ${hexToRgbA(colors.black, 0.15)}`,
  },
}

export default ReviewFooter
